import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import LoadingOverlay from "../../../common/status/LoadingOverlay/LoadingOverlay";

const FormLayout = ({
  children,
  title,
  subtitle,
  isSubmitting,
  onCancel,
  onSubmit,
  actionText = "Save",
  disableSubmit = false,
  error = null,
  loadingConfig = null,
}) => {
  return (
    <View style={styles.container}>
      {loadingConfig && (
        <LoadingOverlay
          visible={loadingConfig.visible}
          step={loadingConfig.step}
          progress={loadingConfig.progress}
          message={loadingConfig.message}
          isCancellable={loadingConfig.isCancellable}
          onCancel={loadingConfig.onCancel}
        />
      )}

      <View style={styles.header}>
        <CustomText text={title} size="xl" weight="bold" style={{ paddingHorizontal: 32 }} useTranslationText={false} />
        {subtitle && (
          <CustomText
            text={subtitle}
            size="m"
            style={{ paddingHorizontal: 32, paddingTop: 4, color: "#667085" }}
            useTranslationText={false}
          />
        )}
      </View>

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={true}>
        <View style={styles.content}>
          <CustomSpacing type="vertical" size="xl" />
          {children}

          {error && (
            <>
              <CustomSpacing type="vertical" size="m" />
              <CustomText text={error} size="m" useTranslationText={false} style={styles.errorText} />
            </>
          )}

          <View style={styles.buttons}>
            <CustomButton
              text="Cancel"
              styleType="primaryLight"
              size="s"
              textStyle={{ fontSize: 14, fontWeight: 700 }}
              style={styles.cancelButton}
              onPress={onCancel}
            />
            <CustomSpacing type="horizontal" size="s" />
            <CustomButton
              text={actionText}
              size="s"
              textStyle={{ fontSize: 14, fontWeight: 700 }}
              onPress={onSubmit}
              styleType="primary"
              disabled={disableSubmit || isSubmitting}
              style={disableSubmit || isSubmitting ? { backgroundColor: "#ccc" } : {}}
            />
          </View>

          {/* Add extra padding at the bottom for scrolling */}
          <CustomSpacing type="vertical" size="xl" />
          <CustomSpacing type="vertical" size="xl" />
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: "100%",
  },
  header: {
    paddingVertical: 32,
    backgroundColor: "#F2F4F7",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  content: {
    paddingHorizontal: 32,
    paddingBottom: 40,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginTop: 24,
  },
  cancelButton: {
    borderColor: "#3E68FE",
    borderWidth: 2,
  },
  errorText: {
    color: "#FF0000",
    marginTop: 8,
  },
});

export default FormLayout;
